import { render, staticRenderFns } from "./newEdition.vue?vue&type=template&id=aa5ca664&scoped=true&"
import script from "./newEdition.js?vue&type=script&lang=js&"
export * from "./newEdition.js?vue&type=script&lang=js&"
import style0 from "./newEdition.vue?vue&type=style&index=0&id=aa5ca664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5ca664",
  null
  
)

export default component.exports